import React, { useEffect, useState } from 'react';
import { Text } from 'components';
import { ICategoryGroup } from 'types';
import { toTitleCase } from 'utils/strings';
import { DetailsContainer, DetailsItem, ItemContainer, StyledIconButton } from '../../../styles';
import { Column, DetailsText, StyledButtonText, StyledRow } from '../../shared/styles';

interface ISalesGroupItemProps {
  categoryGroup: ICategoryGroup;
  disabled?: boolean;
  onEdit?(): void;
  onDelete?(): void;
}

export const SalesGroupItem: React.FC<ISalesGroupItemProps> = ({ categoryGroup, disabled, onEdit, onDelete }) => {
  const [categoriesVisible, setCategoriesVisible] = useState(false);

  useEffect(() => setCategoriesVisible(false), [categoryGroup]);

  return (
    <ItemContainer data-cy="sales-group-item">
      <StyledRow>
        <Column>
          <Text size="small" fontWeight="semibold" capitalize>
            {toTitleCase(categoryGroup.name)}
          </Text>
          <StyledButtonText label={categoriesVisible ? 'Hide Categories' : 'View Categories'} onClick={() => setCategoriesVisible(!categoriesVisible)} />
        </Column>

        {!disabled && (
          <div>
            <StyledIconButton label="Edit" onClick={onEdit} appearance="white" size="small" icon="Edit" data-cy="edit-button" disabled={disabled} />
            <StyledIconButton label="Remove" onClick={onDelete} appearance="white" size="small" icon="Close" data-cy="remove-button" disabled={disabled} />
          </div>
        )}
      </StyledRow>

      {categoriesVisible && (
        <DetailsContainer data-cy="categories-details">
          <Text size="xxsmall" fontWeight="medium">
            Categories
          </Text>
          {categoryGroup.categories.map((name) => (
            <DetailsItem key={`category-${name}`}>
              <DetailsText as="span" size="xsmall" fontWeight="semibold">
                {toTitleCase(name)}
              </DetailsText>
            </DetailsItem>
          ))}
        </DetailsContainer>
      )}
    </ItemContainer>
  );
};
